$(->
  # TODO - brittany 10/5 - Stale? This code originally controlled the careers page link in careers_page.html.erb,
  # but that link is now copy_careers_page_button, not copy_link 
  # (see https://github.com/CareerPlug/ats/commit/af9087ff759cb99736949585ebdb8777897cddbe)
  $(document).on 'click', '.copy_link', (ev)->
    ev.preventDefault()
    the_link = $($(this).attr('href'))
    if the_link.is(':visible')
      the_link.after('<input class="form-control link_input" type="text" value="' + the_link.attr('href') + '" />')
      the_link.siblings('input.link_input').select()
      the_link.hide()
      $(this).html('Done')
    else
      the_link.siblings('input.link_input').remove()
      the_link.show()
      $(this).html('Copy')
    return false

)
